var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unreadCount)?_c('span',{staticClass:"inline-block ml-2 px-2 leading-snug rounded-full text-xs font-bold text-white bg-error"},[_vm._v("\n    "+_vm._s(_vm.unreadCount)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }